import { Typography, Box } from "@mui/material";
import { styled } from "@mui/system";

import {
  //  GOOGLE_AUTH_URL,
  OUTLOOK_AUTH_URL,
} from "constants";

const CustomAnchor = styled("a")(({ theme }) => ({
  cursor: "pointer",
  color: "unset",
  textDecoration: "unset",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 12,
  padding: "12px 16px",
  borderRadius: 12,
  border: `1.5px solid ${theme.palette.login.buttonBorder}`,
  backgroundColor: theme.palette.login.buttonBg,
  boxShadow: `0 1px 2px ${theme.palette.login.buttonShadow}`,
  transition:
    "background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease",
  "&:hover": {
    backgroundColor: theme.palette.login.buttonHoverBg,
    borderColor: theme.palette.login.navy,
    boxShadow: `0 8px 20px -6px ${theme.palette.login.buttonHoverShadow}`,
    transform: "translateY(-1px)",
  },
  "&:active": {
    transform: "translateY(0)",
    boxShadow: `0 2px 6px ${theme.palette.login.buttonActiveShadow}`,
  },
  "&:focus-visible": {
    outline: `3px solid ${theme.palette.login.buttonFocusOutline}`,
    outlineOffset: 2,
  },
}));

function Oauth() {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2} width={"100%"}>
      {/* <CustomAnchor href={GOOGLE_AUTH_URL}>
        <img width={28} src="/assets/google.png" alt="google link " />
        <Typography fontSize={16} fontWeight={600} color="login.navy">
          Continue with Google
        </Typography>
      </CustomAnchor> */}
      <CustomAnchor href={OUTLOOK_AUTH_URL}>
        <img width={28} src="/assets/outlook.png" alt="outlook link " />
        <Typography fontSize={16} fontWeight={600} color="login.navy">
          Continue with Outlook
        </Typography>
      </CustomAnchor>
    </Box>
  );
}
export default Oauth;
